import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import {
    STORE_USERNAME,
} from '../reducers/forgotLink';
import { STORE_ERROR_MESSAGE, STORE_ERROR_BAR, STORE_SUCCESS_MESSAGE, STORE_SUCCESS_BAR, STORE_SUCCESS_TITLE } from 'src/reducers/errors';
// import { STORE_ERROR_MESSAGE, STORE_ERROR_BAR } from '../reducers/errors';
import axios from 'axios';

export const getForgotLinkPage = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const userName: string = '';
    dispatch({ type: STORE_USERNAME, userName } as AnyAction);
};

export const saveUsername = (userName: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_USERNAME, userName } as AnyAction);
        return true;
    };
};

export const doForgotLink = async (
    dispatch: Dispatch<AppState>,
    getState: () => AppState
) => {
    const params = {
        userName: '',
    };
    params.userName = getState().forgotLink.userName || '';

    if (params.userName === '') {
        const errorBar = true;
        const errorMessage = 'Please enter Username';
        dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
        dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
        return;
    } else {
        const errorBar = false;
        dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    }

    try {
        await axios.get(`${getState().environment.API_URL}sendResetLink?userName=${getState().forgotLink.userName}`);

        // console.error(response);
        const successBar = true;
        const successTitle = true;
        const successMessage =
            'We will send verification link to your registered email-id';
        dispatch({ type: STORE_SUCCESS_MESSAGE, successMessage } as AnyAction);
        dispatch({ type: STORE_SUCCESS_BAR, successBar } as AnyAction);
        dispatch({ type: STORE_SUCCESS_TITLE, successTitle } as AnyAction);
        const userName = '';
        dispatch({ type: STORE_USERNAME, userName } as AnyAction);
        return;
    } catch (e) {

        const userName = '';
        dispatch({ type: STORE_USERNAME, userName } as AnyAction);
        // ==> console.error(e);
        const errorBar = true;
        const errorMessage = e.response.data.msg;
        dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
        dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    }
};



// WEBPACK FOOTER //
// ./src/actions/forgotLinkAction.ts